import  { useContext, useState, useCallback } from 'react';
import axios from 'axios';
import AppContext from '../components/AppContext'; 
import config from '../config';

const decodeJWT = (token) => {
  const base64Url = token.split('.')[1]; // Obtener la segunda parte (payload)
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convertir de Base64Url a Base64
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);  // Retorna el payload decodificado
}

const useAuth = (onSuccess) => {
  const { ctxUser, setCtxUser, authLoading, setAuthLoading } = useContext(AppContext);
  const [localLoading, setLocalLoading] = useState(false);  

  const loading = setAuthLoading ? authLoading : localLoading;
  const updateLoading = setAuthLoading || setLocalLoading;

  const checkLogin = useCallback(() => {
    const token = localStorage.getItem('googleToken');
    const loginTime = localStorage.getItem('loginTime');
    
    const result = {
      status: false,
      token: undefined
    };

    if (token && loginTime) {
      const now = new Date();
      const timeElapsed = now.getTime() - loginTime;
      const oneDay = 24 * 60 * 60 * 1000; // 24 horas en milisegundos
      const maxDuration = 14 * oneDay; // 2 setmanas
      
      if (timeElapsed < maxDuration) {
        // El token sigue siendo válido
        result.token = token;
        result.status = true;
        return result;
      } else {
        // El token ha expirado
        localStorage.removeItem('googleToken');
        localStorage.removeItem('loginTime');
      }
    }
    return result;
  }, []);

  const doLogin = useCallback((token) => {
    // Guardar el token y la marca de tiempo en localStorage
    localStorage.setItem('googleToken', token);
    localStorage.setItem('loginTime', new Date().getTime());

    const decodedToken = decodeJWT(token);
    if((!ctxUser || ctxUser.token !== token || !ctxUser.isAuthenticated) && !loading) {
      updateLoading(true);
      // Netejar possible error anterior mentre s'intenta autenticar
      setCtxUser(prev => prev ? { ...prev, error: null } : null);

      //Login to FDVBanc
      axios.post(`${config.apiBaseUrl}/v1/usuari/loginGoogle2`, token)
      .then((response) => {
        const newCtxUser = {
          token: token,
          decodedToken,
          fdvToken: response.data,
          isAuthenticated: true,
          error: null
        };
        setCtxUser(newCtxUser);  
        if (onSuccess) onSuccess(newCtxUser);
      })
      .catch((err) => {
        console.error('Error login FDVBanc:', err);
        const newCtxUser = {
          token: token,
          decodedToken,
          isAuthenticated: false,
          error: err
        };
        setCtxUser(newCtxUser);
        localStorage.removeItem('googleToken');
        localStorage.removeItem('loginTime');
      })
      .finally(() => updateLoading(false));
    }
  }, [ctxUser, loading, onSuccess, setCtxUser, updateLoading]);

  const doLogout = useCallback(() => {
    setCtxUser(undefined);
    localStorage.removeItem('googleToken');
    localStorage.removeItem('loginTime');
  }, [setCtxUser]);

  let myCtxUser = {
    isAuthenticated: false
  };

  if(ctxUser) {
    myCtxUser = ctxUser;
  }
  //setCtxUser(myCtxUser);

  return { ctxUser: myCtxUser, checkLogin, doLogin, doLogout, loading };
};
export default useAuth;